// services/supportService.js

import apiClient from "./apiClient" // ⬅️ adjust the path if your apiClient is elsewhere

const HOME_PATH = "/api/v3/home"

export const createSupportQueryApi = async (data) => {
  const isFormData = typeof FormData !== "undefined" && data instanceof FormData

  const response = await apiClient.post(
    `${HOME_PATH}/createSupportQuery`,
    data,
    isFormData
      ? {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      : undefined
  )

  return response.data
}

